// App.js
import React, { useState, useEffect } from 'react';
import SplashScreen from './pages/splash/SplashScreen ';
import Home from "./pages/home/Home"
const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulez une tâche asynchrone (par exemple, le chargement de données)
    const fakeAsyncTask = () => {
      setTimeout(() => {
        setLoading(false);
      }, 4500); // Temps de chargement simulé : 2 secondes
    };

    fakeAsyncTask();
  }, []);

  return (
    <div>
      {loading ? (
        <SplashScreen />
      ) : (
        <div>
          {/* Affichez le contenu principal de votre application */}
          <Home />
        </div>
      )}
    </div>
  );
};

export default App;
